import { API_BASE_URL } from "../services/httpClient";

/**
 * Construit l'URL de base pour les assets en extrayant le domaine et le port
 * de l'URL de l'API, sans le chemin /api/v1
 */
const buildAssetBaseUrl = () => {
  try {
    const fallback =
      typeof window !== "undefined" ? window.location.origin : undefined;
    const apiUrl = new URL(API_BASE_URL, fallback);
    // Retirer le chemin /api/v1 pour obtenir juste le domaine:port
    return `${apiUrl.protocol}//${apiUrl.host}`;
  } catch {
    return typeof window !== "undefined" ? window.location.origin : "";
  }
};

const ASSET_BASE_URL = buildAssetBaseUrl();

/**
 * Résout l'URL d'un asset (image, etc.)
 *
 * Le backend renvoie maintenant des URLs absolues (ex: http://localhost:5000/uploads/...),
 * donc on les retourne directement sans transformation.
 *
 * Pour les URLs relatives (fallback), on construit l'URL complète à partir de l'URL de base.
 */
export const resolveAssetUrl = (value?: string | null): string | null => {
  if (!value) {
    return null;
  }

  // Si c'est déjà une URL absolue (http:// ou https://), la retourner telle quelle
  // C'est le cas normal maintenant que le backend renvoie des URLs absolues
  if (value.startsWith("http://") || value.startsWith("https://")) {
    return value;
  }

  // Fallback pour les URLs relatives (ne devrait plus arriver normalement)
  // Normaliser le chemin (s'assurer qu'il commence par /)
  const normalized = value.startsWith("/") ? value : `/${value}`;
  return `${ASSET_BASE_URL}${normalized}`;
};
